<script>

import VueApexCharts from 'vue-apexcharts'

export default {
  components: { VueApexCharts },
  data() {
    return {
      dateRange: { startDate: this.moment().subtract(6, 'days').startOf('day').toDate(), endDate: this.moment().endOf('day').toDate() },

      loading: true,

      filters: {
        total: 0,
        betweens: {
          created_at: {
            start: '',
            end: ''
          }
        },
        whereins: {
          website: [],
        },
      },

      dates: [],
      views: [],
      users: [],
      total_views: 0,
      total_users: 0,
    }
  },
  watch: {
    'dateRange': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.created_at.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.created_at.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.created_at.start = '';
        this.filters.betweens.created_at.end = '';
      }
      this.fetchData();
    }, deep: true },
  },
  created() {
    this.filters.whereins.website = [this.website_id];
    this.filters.betweens.created_at.start = this.moment(this.dateRange.startDate).startOf('day').format();
    this.filters.betweens.created_at.end = this.moment(this.dateRange.endDate).endOf('day').format();
    
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.dates = [], this.views = [], this.users = [], this.total_views = 0, this.total_users = 0;
      this.$http.get('/api/pageviews/chart', {params: this.filters}).then(res => {
        // console.log(res);
        for(var i in res.data.data) {
          this.dates.push(res.data.data[i].date);
          this.views.push(res.data.data[i].views);
          this.total_views = this.total_views+res.data.data[i].views;
        }
        for(var i in res.data.data2) {
          this.users.push(res.data.data2[i].views);
          this.total_users = this.total_users+res.data.data2[i].views;
        }
        this.loading = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
  }
}
</script>

<template>
  <div class="card-box position-relative">
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>
    <div class="float-right">
      <div class="form-inline">
        <w-field class="ml-2" SimpleDataType="Date range" v-model="dateRange" placeholder="Filter by date created..." :Disabled="loading"></w-field>
        <w-field class="ml-2" SimpleDataType="String List, Multi" :Options="app_website_ids" v-model="filters.whereins.website" placeholder="Websites..." @input="fetchData()" :Disabled="loading"></w-field>
      </div>
    </div>
    <h4 class="header-title"><Icon icon="ri:bar-chart-2-line" /> Page views</h4>
    <small>Views: {{total_views}} Users: {{total_users}} Days: {{moment(filters.betweens.created_at.end).diff(moment(filters.betweens.created_at.start), 'days') +1}}</small>
    <div v-show="this.total_views" style="height:328px">
      <vue-apex-charts type="bar"
        :options="{
          chart: {
            height: '100%',
            id: 'vuechart-example'
          },
          xaxis: {
            categories: dates
          }
        }"
        :series="[{
          name: 'Page views',
          data: views
        },
        {
          name: 'Users',
          data: users
        }]">
      </vue-apex-charts>
    </div>
  </div>
</template>
